import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'safeSliceHtml'
})
export class SafeSliceHtmlPipe implements PipeTransform {
    transform(value: string, maxLength: number): string {
        if (!value) return '';

        // Parse the input HTML into a DOM element
        const div = document.createElement('div');
        div.innerHTML = value;

        // Extract text content and slice it to the desired length
        const textContent = div.textContent || '';
        const truncatedText = textContent.slice(0, maxLength);

        // Rebuild the HTML structure from the truncated text
        const resultDiv = document.createElement('div');
        let count = 0;

        const walker = document.createTreeWalker(div, NodeFilter.SHOW_TEXT, null);
        while (walker.nextNode()) {
            const currentNode = walker.currentNode;
            const remainingChars = maxLength - count;

            if (remainingChars <= 0) break;

            if (currentNode.nodeValue!.length > remainingChars) {
                currentNode.nodeValue = currentNode.nodeValue!.slice(0, remainingChars);
            }

            count += currentNode.nodeValue!.length;
            resultDiv.appendChild(currentNode.parentNode!.cloneNode(true));
        }

        // Return the truncated HTML content
        return resultDiv.innerHTML;
    }
}
